function ReloadDialog() {
    var $ = jQuery;

    var TEMPLATE = '<div class="ReloadDialog dialog">' +
        '<p class="MESSAGE">Please reload the page</p>' +
        '</div>';

    var dialog = $(TEMPLATE);
    dialog.find(".MESSAGE").text(L10N.getString("RELOAD_AFTER_LOGIN"));

    return dialog;
}